module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading || _vm.loadingFinished),
      expression: "loading || loadingFinished"
    }]
  }, [_c('transition', {
    attrs: {
      "name": "loading-finished",
      "duration": 600
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingFinished),
      expression: "loadingFinished"
    }],
    staticClass: "loading-finished",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": _vm.size,
      "height": _vm.size,
      "viewBox": "0 0 440 440"
    }
  }, [_c('g', {
    attrs: {
      "stroke": _vm.color,
      "fill": "none",
      "stroke-linecap": "round"
    }
  }, [_c('circle', {
    staticClass: "finished-circle",
    attrs: {
      "cx": "220",
      "cy": "220",
      "r": "200",
      "stroke-width": _vm.circleWidth,
      "transform": "rotate(-90, 220 220)",
      "stroke-dasharray": "1256.5",
      "stroke-dashoffset": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120 230 L190 300 L320 160",
      "stroke-width": _vm.circleWidth,
      "stroke-linejoin": "round",
      "stroke-dasharray": "291.1 0",
      "stroke-dashoffset": "1"
    }
  })])])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.loadingFinished),
      expression: "loading && !loadingFinished"
    }],
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": _vm.size,
      "height": _vm.size,
      "viewBox": "0 0 440 440"
    }
  }, [_c('g', {
    attrs: {
      "stroke": _vm.color,
      "fill": "none",
      "stroke-linecap": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "220",
      "cy": "220",
      "r": "200",
      "stroke-width": _vm.circleWidth,
      "transform": "rotate(-90, 220 220)"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dasharray",
      "begin": "0",
      "dur": "1.2",
      "repeatCount": "indefinite",
      "calcMode": "spline",
      "values": "2 1254.5; 942.375 314.125; 2 1254.5",
      "keyTimes": "0; .2; 1",
      "keySplines": "0 0 1 1; 0 .5 .5 1"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "stroke-dashoffset",
      "begin": "0",
      "dur": "1.2",
      "repeatCount": "indefinite",
      "calcMode": "spline",
      "values": "1; 1; -1255.5",
      "keyTimes": "0; .2; 1",
      "keySplines": "0 0 1 1; 0 .5 .5 1"
    }
  })])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4964089c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4964089c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@finance/ssvue/src/components/loading/icon.vue
// module id = 150
// module chunks = 8